var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "not-found" }, [
    _c("div", { staticClass: "error-message zw-orange-text" }, [
      _vm._v("\n\t\t404\n\t")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "error" }, [
      _vm._v("\n\t\t" + _vm._s(_vm.$t("pages.notfound.not_found")) + " "),
      _c("br"),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.goBack.apply(null, arguments)
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("pages.notfound.go_back")))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d29df9ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d29df9ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/errors/NotFoundError.vue
// module id = F9S0
// module chunks = 1